import { useCallback, useState } from "react"
import { useMutationWithEndpoint } from "@hydrologiq/shared/hooks/useGraphQLClient"
import { RemoveSystemDocument } from "@hydrologiq/gql-experience/graphql"

export interface UseRemoveSystemReturn {
  removeSystem: (systemId: string) => Promise<void>
  removing: boolean
  error: string | undefined
}

export function useRemoveSystem(): UseRemoveSystemReturn {
  const [removing, setRemoving] = useState(false)
  const [error, setError] = useState<string | undefined>(undefined)

  const [removeSystemMutation] = useMutationWithEndpoint(
    RemoveSystemDocument,
    undefined,
    "primary",
  )

  const removeSystem = useCallback(
    async (systemId: string) => {
      setRemoving(true)
      setError(undefined)
      try {
        const result = await removeSystemMutation({
          variables: { systemId },
        })
        const { errors } = result
        if (errors?.length) {
          throw new Error(errors[0].message)
        }
      } catch (err: any) {
        const message =
          err?.graphQLErrors?.[0]?.message ||
          err?.message ||
          "Failed to remove system"
        setError(message)
        throw new Error(message)
      } finally {
        setRemoving(false)
      }
    },
    [removeSystemMutation],
  )

  return {
    removeSystem,
    removing,
    error,
  }
}
